import type { useForm } from "hooks";
import type { BooleanSwitch, BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    PreferredCurrency = 'preferredCurrency',
    AvgTransactionNoMonth = 'avgTransactionNoMonth',
    MaxTransactionVolumeMonth = 'maxTransactionVolumeMonth',
    MaxTransactionNoCustomerMonth = 'maxTransactionNoCustomerMonth',
    EstimatedPercentChargebacksRefundsMonth = 'estimatedPercentChargebacksRefundsMonth',
    TransactionNoCurrentMonth = 'transactionNoCurrentMonth',
    AvgTransactionAmount = 'avgTransactionAmount',
    MaxTransactionAmount = 'maxTransactionAmount',
    SalesVolumeCurrentMonth = 'salesVolumeCurrentMonth',
    ExpectedSalesVolumeMonth = 'expectedSalesVolumeMonth',
    IsProcessingHistoryOverSixMonths = 'isProcessingHistoryOverSixMonths',
    UsedPsps = 'usedPsps',
    HasLeftPreviousProcessors = 'hasLeftPreviousProcessors',
    LeftPreviousProcessorsInput = 'leftPreviousProcessorsInput',
    SalesCurrencies = 'salesCurrencies',
    TotalTransactionAmountYearly = 'totalTransactionAmountYearly',
    CurrentPercentChargebacksRefundsRatio = 'currentPercentChargebacksRefundsRatio'
};

export type OnboardingFinancialInformation = {
    readonly [FormField.PreferredCurrency]: string | null;
    readonly [FormField.AvgTransactionNoMonth]: string;
    readonly [FormField.MaxTransactionVolumeMonth]: string;
    readonly [FormField.MaxTransactionNoCustomerMonth]: string;
    readonly [FormField.EstimatedPercentChargebacksRefundsMonth]: string;
    readonly [FormField.TransactionNoCurrentMonth]: string;
    readonly [FormField.AvgTransactionAmount]: string;
    readonly [FormField.MaxTransactionAmount]: string;
    readonly [FormField.SalesVolumeCurrentMonth]: string;
    readonly [FormField.ExpectedSalesVolumeMonth]: string;
    readonly [FormField.IsProcessingHistoryOverSixMonths]: BooleanSwitch | null;
    readonly [FormField.UsedPsps]: string;
    readonly [FormField.HasLeftPreviousProcessors]: BooleanSwitch | null;
    readonly [FormField.LeftPreviousProcessorsInput]: string | null;
    readonly [FormField.SalesCurrencies]: Array<string>;
    readonly [FormField.TotalTransactionAmountYearly]: string;
    readonly [FormField.CurrentPercentChargebacksRefundsRatio]: string;
};

export type OnboardingFinancialInformationBootstrapData = {
    readonly [FormField.MaxTransactionVolumeMonth]: Array<string>;
    readonly [FormField.SalesVolumeCurrentMonth]: Array<string>;
    readonly [FormField.ExpectedSalesVolumeMonth]: Array<string>;
};

export type OnboardingFinancialInformationForm = Omit<
    BootstrapableForm<OnboardingFinancialInformation, OnboardingFinancialInformationBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingFinancialInformation;
};

export type OnboardingFinancialInformationProps =
    & OnboardingFormProps
    & OnboardingFinancialInformationForm
    & ReturnType<typeof useForm<OnboardingFinancialInformation>>;
